import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue';
    import { useRouter } from 'vue-router/composables';
    import emitter from '@/utils/mitt';
    import { alertError } from '@/utils/dialogs';
    import { ToastProgrammatic as Toast } from 'buefy';
    import THGTagForm from '@/components/thg/tags/THGTagForm.vue';
    import { THGTag } from '@/interfaces/thg/THGTag';
    import { addTHGTag } from '@/api/thg/tags';

    
export default /*#__PURE__*/_defineComponent({
  __name: 'NewTHGTag',
  setup(__props) {

    const router = useRouter();
    const newTag = ref<THGTag>({});

    async function addTag() {
        emitter.emit('showLoader');

        // do the actual update
        const response = await addTHGTag(newTag.value);

        if (response.status !== 200) {
            if (response.status === 409) {
                alertError(
                    'Fehler',
                    `Ein Tag mit dem Namen <b>${newTag.value.name}</b> existiert bereits.`,
                );
            } else {
                alertError('Fehler', 'Fehler beim Speichern des Tags.');
            }
        } else {
            Toast.open({ type: 'is-success', message: 'Tag erfolgreich angelegt.' });
            router.push({ name: 'thgtagslist' });
        }

        emitter.emit('hideLoader');
    }

return { __sfc: true,router, newTag, addTag, THGTagForm }
}

})